import { useAppSelector } from 'js/store/hooks';
import { pick } from 'ramda';
import { useMemo } from 'react';

export const useSkipAutoLoginDependency = () => {
    const {
        casinoName,
        skipAutoLoginDependency
    } = useAppSelector(pick(['casinoName', 'skipAutoLoginDependency']));

    return useMemo(() => {
        return skipAutoLoginDependency
            && !document.cookie.includes(`pas[${casinoName}][real][isOnline]=1`)
            && !new URLSearchParams(location.search).has('username');
    }, [
        casinoName,
        skipAutoLoginDependency
    ]);
};
